import { useTranslation } from "react-i18next";

export const useLanguageDirection = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const dir = lang === "ar" ? "rtl" : "ltr";
  return { lang, dir };
};
